<div class="ingreso-container"
  [style.background-image]="'url(./assets/img/' + (sede ? 'fondo-web-sedes.jpg' : 'fondo-web.jpg') + ')'">
  <div class="lazy-wrapper" *ngFor="let page of pages; let i = index" #lazyWrapper>
    <ng-container #dynamicContainer></ng-container>
  </div>
</div>